import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { OperatorDrawerNavs } from '@ibk/shared-types';
import OperatorDrawerHome from './pages/Home';
import OperatorDrawerRegisterForm from './pages/RegisterForm';
import OperatorDrawerRegisterType from './pages/RegisterType';
const ROUTE_COMPONENTS = {
    [OperatorDrawerNavs.REGISTER_FORM]: OperatorDrawerRegisterForm,
    [OperatorDrawerNavs.REGISTER_TYPE]: OperatorDrawerRegisterType,
};
const DrawerOperatorNavigationComponent = ({ currentRoute, ...props }) => {
    const Component = ROUTE_COMPONENTS[currentRoute.route] ?? OperatorDrawerHome;
    return _jsx(Component, { ...props, currentRoute: currentRoute });
};
export const DrawerOperatorNavigation = React.memo(DrawerOperatorNavigationComponent);
DrawerOperatorNavigation.displayName = 'DrawerOperatorNavigation';
export default DrawerOperatorNavigation;
